import './App.css';

import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useParams, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import HeadManager from './HeadManager';
import PageControl from './PageControl';

const RouteHandler = ({ language, setLanguage }) => {
  const { language: urlLanguage, pageName } = useParams();
  const navigate = useNavigate(); 
  const [data, setData] = useState(null); 
  const assetsPath = process.env.REACT_APP_ASSETS_PATH || '#{ASSETS_PATH}';
  const { i18n } = useTranslation();
  
  useEffect(() => {
    const fetchData = async () => {
      let dataUrl = `${assetsPath}/data.json`; // Default data URL
      if (pageName) {
        dataUrl = `${assetsPath}/${pageName}/data.json`; // If pageName exists, update data URL
      }

      const response = await fetch(dataUrl);

      const contentType = response.headers.get('Content-Type');
      if (!response.ok || !contentType || !contentType.includes('application/json')) {
        // Redirect to home page
        navigate('/');
        return;
      }
  
      // if (!response.ok) {
      //   throw new Error(`HTTP error! status: ${response.status}`);
      // }

      const fetchedData = await response.json();
      setData(fetchedData); 

      let newLanguage = fetchedData.defaultLanguage; // Default to fetched language

      if (urlLanguage && urlLanguage !== language) {
        newLanguage = urlLanguage;
      } 
      setLanguage(newLanguage); 
      i18n.changeLanguage(newLanguage);
    };

    fetchData().catch((error) => console.error(error));
  // eslint-disable-next-line    
  }, [pageName, urlLanguage]);

  return (
    <div className="App">
      {data && (
        <>
          <HeadManager pageData={data} language={language} />
          <PageControl pageData={data} language={language} />
        </>
      )}
    </div>
  );
};

/** workaround to get the expire cookie to work. Probably will need some more code/thoughts. */
const RedirectToReferrerOrRoot = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const referrer = params.get('referrer');

  useEffect(() => {
    if (referrer) {
      const referrerUrl = new URL(referrer);
      if (referrerUrl.hostname === window.location.hostname) {
        navigate(referrerUrl.pathname, { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    } else {
      navigate('/', { replace: true });
    }
  }, [navigate, referrer]);

  return null;
};

function App() {
  //const [language, setLanguage] = useState(data.language);
  const [language, setLanguage] = useState(null);

  return (
    <Router>
      <Routes>
        <Route path="/:language?/:pageName?" element={<RouteHandler language={language} setLanguage={setLanguage} />} />
        <Route path="/activeinvest_expirecookie.aspx" element={<RedirectToReferrerOrRoot language={language} />} />
      </Routes>
    </Router>
  );
}

export default App;
